/**
 * Created by Steven-DESK on 14/07/2017.
 */
$(document).ready(function () {
    $("#add_pos").click(function () {
        $("#Inschr_lines").append('<div class="Inschr_line"><h5 class="header_sub_subtitle"> Mogelijkheid <span class="red_cross">&#x2718;</span> </h5><div class="form-group input-group"> <label class="label led_label col-lg-2 col-md-2 col-sm-2 col-xs-12" for="omschr"> Omschrijving: </label> <div class="col-lg-10col-md-10 col-sm-10 col-xs-12"> <textarea id="omschr" name="Omschrijving[]" class="form_input_100"placeholder="Omschrijving"></textarea> </div> </div> <div class="form-group input-group"> <label class="label led_label col-lg-2 col-md-2 col-sm-2 col-xs-12" for="prijs"> Prijs: </label> <div class="col-lg-10col-md-10 col-sm-10 col-xs-12"> <input type="number" id="prijs" name="Prijs[]" class="form_input_100" placeholder="Prijs" min="0" max="999" step="0.01"> </div> </div> </div>')
    });


    let regexEVSuc = /\/evenementen\/index\/Save\/Success/;
    let regexEVFail = /\/evenementen\/index\/Save\/Failed$/;
    let regexEVFailInf = /\/evenementen\/index\/Save\/Failed\/Info/;

    if (regexEVSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Evenementen', '/evenementen');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexEVFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Evenementen', '/evenementen');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexEVFailInf.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Evenementen', '/evenementen');
        $(".save_fail_evi").fadeIn(1000).delay(5000).fadeOut(1000);
    }

    $("#reset_edit").click(function (e) {
        e.preventDefault();
        location.reload();
    });

    $(".open_insch > .poi_cur").click(function () {
        $(this).parent().submit();
    })
});

$(document).on("click", ".red_cross", function () {
    if ($(".Inschr_line").length > 1) {
        $(this).parent().parent().remove();
    } else {
        $(".delete_dyn_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
});



//////////////////
// WEBPACK FOOTER
// ./js/evenementen.js
// module id = 15
// module chunks = 0